import { dataColorPalette } from 'dls-icons-data'
import { createIcon } from '../common'

const IconColorPalette = /*#__PURE__*/createIcon(dataColorPalette)
export default IconColorPalette
